module.exports = __webpack_public_path__ + "img/cloud-blank-02.77f1406b.svg";